import EmployeeEmploymentSubordinatesComponents from "../components/EmployeeEmploymentSubordinates";
import useEmployeeEmploymentSubordinates from "../hooks/useEmployeeEmploymentSubordinates";

function EmployeeEmploymentSubordinates() {
  const subOrdinateProps = useEmployeeEmploymentSubordinates();
  return (
    <EmployeeEmploymentSubordinatesComponents
      {...subOrdinateProps}
    />
  );
}

export default EmployeeEmploymentSubordinates;
